<script setup lang="ts">

import { FilterDateRange, FiltersBar } from '@shared/ui/filters'
import { AppMultiSelect } from '@shared/ui/selects'

import DisciplineFilesSendMenu from './DisciplineFilesSendMenu.vue'
import { useFiltersDisciplineFiles } from '../model/filters-discipline-files.hook'

defineOptions({
  name: 'FiltersDisciplineFiles',
})

const {
  refDateRange,
  refCategories,
  categoryOptions,
  isLoading,
  search,
  clearFilters,
} = useFiltersDisciplineFiles()
</script>

<template>
  <FiltersBar
    class="filters-discipline-files"
    :loading="isLoading"
    @click:submit="search"
    @click:clear="clearFilters"
  >
    <template #fields>
      <FilterDateRange
        v-model="refDateRange"
        presets
        class="filters-discipline-files__date"
        label="Date"
        placeholder="Search"
        :disabled="isLoading"
      />

      <AppMultiSelect
        v-model="refCategories"
        class="filters-discipline-files__type"
        :options="categoryOptions"
        label="Type"
        placeholder="All"
        :disabled="isLoading"
        clearable
      />
    </template>

    <template #end>
      <DisciplineFilesSendMenu />
    </template>
  </FiltersBar>
</template>

<style scoped lang="scss" src="./FiltersDisciplineFiles.scss" />
